
function submitForm(event) {
    event.preventDefault();
    $('.registration-form').submit();
}

const isFormDataValid = () =>
    $('.registration-form').parsley('validate').whenValidate()

function getEmail() {
    return $('#member-email').val();
}

function getPassword() {
    return $('#member-password').val();
}

function getSessionExpiration() {
    return $('.registration-form').data('gigya-session-duration');
}

function showErrorMessages(messages) {
    $('.registration-error-message p').html(messages.join('<br>'));
    $('.registration-error-message').show();
}

function onRegisterButtonClicked(callback) {
    $('#register-button').on('click', callback);
}

function addSpinnerForRegisterButton() {
    // needed to ensure loading spinner on safari
    // which does not play css animations onsubmit
    $('#register-button').addClass('btn-loading');
}

function removeSpinnerForRegisterButton() {
    $('#register-button').removeClass('btn-loading');
}

function disableMemberButton() {
    $('#register-button').prop('disabled', true);
}

function enableMemberButton() {
    $('#register-button').prop('disabled', false);
}

function getFormData() {
    return $('.registration-form').serializeArray();
}

function getFormPostPath() {
    return $('.registration-form').attr('action');
}

function isTempCardRegistration() {
    const tempCardNumber = $('#temporary-card-number').val();
    return tempCardNumber !== undefined && tempCardNumber.length > 0;
}

module.exports = {
    submitForm: submitForm,
    isFormDataValid: isFormDataValid,
    onRegisterButtonClicked: onRegisterButtonClicked,
    addSpinnerForRegisterButton: addSpinnerForRegisterButton,
    removeSpinnerForRegisterButton: removeSpinnerForRegisterButton,
    getFormData: getFormData,
    getEmail: getEmail,
    getPassword: getPassword,
    getSessionExpiration: getSessionExpiration,
    showErrorMessages: showErrorMessages,
    getFormPostPath: getFormPostPath,
    isTempCardRegistration: isTempCardRegistration,
    disableMemberButton: disableMemberButton,
    enableMemberButton: enableMemberButton,
    webUrl: () => $('.registration-form').attr('web-url'),
    hasEnteredTempCardNumber: () => $('.registration-form').attr('data-has-entered-temp-card') === 'true'
};
